/* eslint-disable eqeqeq */
import React from 'react';
import PropTypes from 'prop-types';

export default function InputCNPJ(props) {
	let _inputCNPJ = React.createRef();

	// Validação de CNPJ com suporte ao formato alfanumérico
	// Formato: [A-Z0-9]{12}[0-9]{2} — 12 posições alfanuméricas + 2 dígitos verificadores
	// Cálculo do DV: valor ASCII do caractere - 48 (0=0, 1=1, ..., A=17, B=18, C=19, ...)
	const validarCNPJ = cnpj => {
		// Remove caracteres de formatação (pontos, barra, hífen)
		cnpj = cnpj.replace(/[.\-/]/g, '').toUpperCase();

		if (cnpj == '') return false;

		if (cnpj.length != 14) return false;

		// Valida formato: 12 posições alfanuméricas (A-Z, 0-9) + 2 dígitos numéricos
		if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return false;

		// Elimina CNPJs com todos os caracteres iguais (apenas numéricos)
		if (/^(\d)\1{13}$/.test(cnpj)) return false;

		// Converte caractere para valor numérico usando tabela ASCII - 48
		const charToValue = ch => ch.charCodeAt(0) - 48;

		// Calcula primeiro dígito verificador
		const tamanho1 = 12;
		let soma = 0;
		let pos = tamanho1 - 7;
		for (let i = tamanho1; i >= 1; i--) {
			soma += charToValue(cnpj.charAt(tamanho1 - i)) * pos--;
			if (pos < 2) pos = 9;
		}
		let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
		if (resultado != parseInt(cnpj.charAt(12))) return false;

		// Calcula segundo dígito verificador
		const tamanho2 = 13;
		soma = 0;
		pos = tamanho2 - 7;
		for (let i = tamanho2; i >= 1; i--) {
			soma += charToValue(cnpj.charAt(tamanho2 - i)) * pos--;
			if (pos < 2) pos = 9;
		}
		resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
		if (resultado != parseInt(cnpj.charAt(13))) return false;

		return true;
	};

	// Formata o CNPJ no padrão XX.XXX.XXX/XXXX-XX
	const formatarCNPJ = value => {
		// Remove tudo que não for alfanumérico
		const limpo = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 14);

		if (limpo.length <= 2) return limpo;
		if (limpo.length <= 5) return `${limpo.slice(0, 2)}.${limpo.slice(2)}`;
		if (limpo.length <= 8) return `${limpo.slice(0, 2)}.${limpo.slice(2, 5)}.${limpo.slice(5)}`;
		if (limpo.length <= 12) return `${limpo.slice(0, 2)}.${limpo.slice(2, 5)}.${limpo.slice(5, 8)}/${limpo.slice(8)}`;
		return `${limpo.slice(0, 2)}.${limpo.slice(2, 5)}.${limpo.slice(5, 8)}/${limpo.slice(8, 12)}-${limpo.slice(12)}`;
	};

	// Verifica se o CNPJ foi completamente preenchido (14 caracteres sem formatação)
	const isComplete = value => {
		const limpo = value.replace(/[^A-Za-z0-9]/g, '');
		return limpo.length === 14;
	};

	const handleBlur = evt => {
		validate(evt).then(e => {
			if (typeof props.onBlur === 'function') {
				props.onBlur(e);
			}
		});
	};

	const handleChange = evt => {
		// Aplica formatação ao valor digitado
		const formatted = formatarCNPJ(evt.target.value);
		const syntheticEvt = {
			...evt,
			target: {
				...evt.target,
				value: formatted,
				name: evt.target.name,
				type: evt.target.type,
				required: evt.target.required,
			},
		};
		validate(syntheticEvt).then(e => {
			if (typeof props.onChange === 'function') {
				props.onChange(e);
			}
		});
	};

	const validate = evt =>
		new Promise(resolve => {
			const inputDOMNode = _inputCNPJ.current;
			const complete = isComplete(evt.target.value);
			const valid = complete && validarCNPJ(evt.target.value);
			if (!complete) {
				inputDOMNode.setCustomValidity('Digite o CNPJ corretamente.');
			} else if (!valid) {
				inputDOMNode.setCustomValidity('CNPJ inválido.');
			} else {
				inputDOMNode.setCustomValidity('');
			}
			resolve({
				...evt,
				target: {
					...evt.target,
					type: evt.target.type,
					required: evt.target.required,
					name: evt.target.name,
					validity: {
						...evt.target.validity,
						valid: valid,
					},
				},
			});
		});

	return (
		<input
			ref={_inputCNPJ}
			value={props.value}
			type="text"
			id="cnpj"
			name="cnpj"
			maxLength={18}
			placeholder="XX.XXX.XXX/XXXX-XX"
			onBlur={handleBlur}
			onChange={handleChange}
			required={props.required}
			className={`form-control ${props.invalid && 'is-invalid'}`}
			autoComplete="off"
		/>
	);
}

InputCNPJ.propTypes = {
	onBlur: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	required: PropTypes.bool,
	invalid: PropTypes.bool,
};
